import { render } from "./informationMacth.vue?vue&type=template&id=12bc71b0&scoped=true"
import script from "./informationMacth.vue?vue&type=script&lang=js"
export * from "./informationMacth.vue?vue&type=script&lang=js"

import "./informationMacth.vue?vue&type=style&index=0&id=12bc71b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bc71b0"]])

export default __exports__